<template>
    <section class="content-box-list">
        <slot />
    </section>
</template>

<style lang="scss">
.content-box-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, $element-max-width));
    gap: $content-grid-mobile-gap;
    justify-content: center;
    margin-block-end: 20px;

    @include bp(medium1) {
        grid-template-columns: repeat(2, 1fr);
        gap: $content-grid-tablet-gap;
        margin-block-end: 40px;
    }

    @include bp(large1) {
        grid-template-columns: repeat(2, 1fr);
        gap: $content-grid-desktop-gap;
    }

    @include bp(large2) {
        grid-template-columns: repeat(3, 1fr);
        margin-block-end: 60px;
    }
}
</style>
